import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function CategoryClarificationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-slate-900 py-24 lg:py-32 relative" data-id="element-62">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-64">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight tracking-tight mb-12" data-id="element-65">
            The Missing Layer in Modern Defense Technology
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-66">
            <p data-id="element-67">
              Platforms like{' '}
              <span className="text-white font-semibold" data-id="element-68">Palantir</span> analyze
              operational data.{' '}
              <span className="text-white font-semibold" data-id="element-69">Anduril</span> manages
              autonomous defense systems.{' '}
              <span className="text-white font-semibold" data-id="element-70">Scale AI</span> builds
              infrastructure for training AI models.
            </p>

            <div className="p-8 bg-slate-800/50 border border-tiq-purple/30 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-71">
              <div className="absolute inset-0 bg-tiq-purple/5 blur-2xl -z-10" data-id="element-72" />
              <p className="text-white font-medium relative z-10" data-id="element-73">
                TalentIQ focuses on the missing layer — translating fragmented
                human readiness signals into decision-grade intelligence before
                operational decisions are made.
              </p>
            </div>

            <p className="font-medium text-tiq-blue" data-id="element-74">
              In high-stakes environments, the biggest risk isn't data.
            </p>

            <p className="text-2xl font-bold text-white" data-id="element-75">
              It's whether the people executing the mission are actually ready.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}